import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

type ReliabilityInfoDialogProps = {
  isOpen: boolean
  onClose: () => void
  onReadMore: () => void
}

export const ReliabilityInfoDialog = ({ isOpen, onClose, onReadMore }: ReliabilityInfoDialogProps) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative">
                <button
                  type="button"
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                  onClick={onClose}
                >
                  <span className="sr-only">Close</span>
                  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <Dialog.Title as="h3" className="text-xl font-medium leading-6 text-gray-900">
                  Reliability Score
                </Dialog.Title>
                <div className="mt-2">
                  <p className="text-m text-gray-500">
                    The Reliability Score is a percentage that indicates your progress toward achieving a reliable
                    rating.
                  </p>
                </div>
                <div className="mt-4 flex gap-4">
                  <button
                    type="button"
                    className="w-full inline-flex justify-center rounded-xl bg-gray-200 px-4 py-2 text-m font-medium text-gray-700 hover:bg-gray-300"
                    onClick={onReadMore}
                  >
                    Read More
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
